var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "@recoil/Store";
import { useSetRecoilState } from "recoil";
import { Snackbar, Alert } from "@mui/material";
import * as cutil from "@utils/Cutil";
import * as Const from "@utils/Const";
import { PromiseHttp } from "@utils/api/HttpUtil";
export default function Popup(props) {
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const navigate = useNavigate();
    const setUrl = useSetRecoilState(url);
    const { urls, item } = props;
    const langs = (props.hasOwnProperty("lang")) ? props.lang : null;
    const [password, setPassword] = useState("");
    const Done = (e) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        // 1. 비밀번호 미입력 체크
        if (!password || password.trim() === "") {
            setAlertMsg(langs ? "Please enter your password." : "비밀번호를 입력해 주세요.");
            setOpenAlert(true);
            (_a = document.getElementById("password")) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POST,
            appPath: `/open/board/post/${item.postId}`,
            appQuery: { passwd: password },
            userToken: "",
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                sessionStorage.setItem("password", password);
                cutil.handleUrl(e, urls.depth1, urls.depth2, navigate, setUrl, { mode: Const.URL_DETAIL, id: item.postId });
            }
            else {
                setAlertMsg(langs ? "Incorrect password." : "비밀번호가 일치하지 않습니다.");
                setOpenAlert(true);
                setPassword("");
                (_b = document.getElementById("password")) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
    });
    return (_jsxs(_Fragment, { children: [langs ?
                _jsx("div", Object.assign({ className: "popup-overlay hidden", id: "popup", style: { display: "none" } }, { children: _jsxs("div", Object.assign({ className: "password-box" }, { children: [_jsx("h2", { children: "Private Post" }), _jsx("p", { children: "Please enter the password" }), _jsx("input", { type: "password", placeholder: "Enter password", id: "password", value: password, onChange: (e) => setPassword(e.target.value) }), _jsxs("div", Object.assign({ className: "button-area" }, { children: [_jsx("button", Object.assign({ type: "button", id: "cancelBtn", onClick: (e) => cutil.popupClose("popup") }, { children: "Cancel" })), _jsx("button", Object.assign({ type: "button", id: "confirmBtn", onClick: (e) => Done(e) }, { children: "Confirm" }))] }))] })) }))
                :
                    _jsx("div", Object.assign({ className: "popup-overlay hidden", id: "popup", style: { display: "none" } }, { children: _jsxs("div", Object.assign({ className: "password-box" }, { children: [_jsx("h2", { children: "\uBE44\uBC00\uAE00\uC785\uB2C8\uB2E4" }), _jsx("p", { children: "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694" }), _jsx("input", { type: "password", placeholder: "\uBE44\uBC00\uBC88\uD638 \uC785\uB825", id: "password", value: password, onChange: (e) => setPassword(e.target.value) }), _jsxs("div", Object.assign({ className: "button-area" }, { children: [_jsx("button", Object.assign({ type: "button", id: "cancelBtn", onClick: (e) => cutil.popupClose("popup") }, { children: "\uCDE8\uC18C" })), _jsx("button", Object.assign({ type: "button", id: "confirmBtn", onClick: (e) => Done(e) }, { children: "\uD655\uC778" }))] }))] })) })), _jsx(Snackbar, Object.assign({ open: openAlert, autoHideDuration: 3000, onClose: () => setOpenAlert(false), anchorOrigin: { vertical: 'top', horizontal: 'center' } }, { children: _jsx(Alert, Object.assign({ severity: "info", variant: "filled", sx: { width: '100%' } }, { children: alertMsg })) }))] }));
}
